import React, { useEffect } from 'react'
import Head from 'next/head'
import JumpstartFocusPage from 'pages/website/LandingPage/EntrepreneurSeminar/FocusPage/JumpstartFocusPage'
import content from 'pages/website/LandingPage/EntrepreneurSeminar/FocusPage/content/jumpstartTrial'
import useJumpstartIntake from 'pages/website/LandingPage/EntrepreneurSeminar/useJumpstartIntake'
import { trackAmplitude } from 'services/amplitude/amplitude'
import CommonHead from '../_head'

/**
 * Paid-social landing page for the whole-business Jumpstart, sold as the 7-day free trial. Noindex, like
 * /jumpstart-mw. No focus is recorded, so the member gets the standard programme. The intake source is the page's
 * path, as on every Jumpstart lander, and Amplitude tells the page apart by its page key.
 */
const JumpstartTrial = () => {
  const onIntakeSubmit = useJumpstartIntake('jumpstart-mw-trial')

  useEffect(
    () => trackAmplitude('program_viewed', { program_id: 'jumpstart', program_name: 'Jumpstart', page: 'trial' }),
    [],
  )

  return (
    <>
      <Head>
        <title>{content.META.title}</title>
        <meta name="robots" content="noindex, nofollow" />
        <CommonHead description={content.META.description} />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Inter:opsz,wght@14..32,400..900&family=Rubik:wght@400..800&display=swap"
        />
      </Head>
      <JumpstartFocusPage content={content} onIntakeSubmit={onIntakeSubmit} />
    </>
  )
}

export const getServerSideProps = () => ({ props: { topNavActive: false, footerActive: false } })

export default JumpstartTrial
